import * as Status from '../../../constants/status';
import { partitionByGpsValidity } from '../../../utils/nsirMapConfig';
import {
  BACKLOG_STATUSES,
  FINALIZADAS_STATUSES,
  KPI_KEYS,
} from './constants';

const EM_INSPECAO_STATUSES = [Status.EM_INSPECAO, Status.EM_CRIACAO];

export const computeMapMetrics = (nsirs) => {
  const { validas, invalidas } = partitionByGpsValidity(nsirs);

  const metrics = {
    [KPI_KEYS.TOTAL]: validas.length,
    [KPI_KEYS.ANOMALIAS]: 0,
    [KPI_KEYS.AGUARDANDO]: 0,
    [KPI_KEYS.EM_INSPECAO]: 0,
    [KPI_KEYS.FINALIZADAS]: 0,
    [KPI_KEYS.GPS_ERRORS]: invalidas.length,
  };

  validas.forEach((nsir) => {
    if (nsir.anomalia === true) metrics[KPI_KEYS.ANOMALIAS] += 1;
    if (nsir.status === Status.AGUARDANDO_INSPECAO) metrics[KPI_KEYS.AGUARDANDO] += 1;
    if (EM_INSPECAO_STATUSES.includes(nsir.status)) metrics[KPI_KEYS.EM_INSPECAO] += 1;
    if (FINALIZADAS_STATUSES.includes(nsir.status)) metrics[KPI_KEYS.FINALIZADAS] += 1;
  });

  return { metrics, validas, invalidas };
};

export const getMetricCount = (metrics, key) => metrics?.[key] ?? 0;
